export var entityFieldMutationFragment = function (fieldDefn) {
  switch (fieldDefn.type) {
    case 'longText':
      return "".concat(fieldDefn.name, " { id text }");
    case 'file':
    case 'image':
      return "".concat(fieldDefn.name, " { ...FileUpdateFields }");
    case 'linked':
    case 'linkedMultiple':
      return "".concat(fieldDefn.name, " { ...EntityValueFields }");
    default:
      return "".concat(fieldDefn.name);
  }
};